var _mask, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 21,
    viewBox: "0 0 21 21",
    width: 21,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a",
    height: 21,
    maskUnits: "userSpaceOnUse",
    width: 21,
    x: 0,
    y: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h21v21h-21z",
    fill: "#d9d9d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m10.5 17.5c-1.95417 0-3.60937-.6781-4.96562-2.0344-1.35626-1.3562-2.03438-3.0114-2.03438-4.9656 0-1.95417.67812-3.60937 2.03438-4.96562 1.35625-1.35626 3.01145-2.03438 4.96562-2.03438 1.0062 0 1.9688.20781 2.8875.62344.9188.41562 1.7063 1.00989 2.3625 1.78281v-2.40625h1.75v6.125h-6.125v-1.75h3.675c-.4667-.81667-1.1047-1.45833-1.9141-1.925-.8093-.46667-1.688-.7-2.6359-.7-1.45833 0-2.69792.51042-3.71875 1.53125s-1.53125 2.26042-1.53125 3.71875c0 1.4583.51042 2.6979 1.53125 3.7188 1.02083 1.0208 2.26042 1.5312 3.71875 1.5312 1.1229 0 2.1365-.3208 3.0406-.9625.9042-.6417 1.5386-1.4875 1.9032-2.5375h1.8374c-.4083 1.5458-1.2395 2.8073-2.4937 3.7844s-2.6833 1.4656-4.2875 1.4656z",
    fill: "#1c1b1f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.d0f37fa256c69fe45b20f0c692988e25.svg";
export { ForwardRef as ReactComponent };